import LoginButtons from "../components/admin/sidebar/items/login/LoginButtons";
import React from "react";
import {useStores} from "../stores/useStores";

export default function LoginPage(props) {
    const {organizationStore} = useStores();

    return <div>
        <div id="sb-main-content" className="sb-login-container sb-content-width" style={{maxWidth: "600px", minHeight: 0}}>
            <div className="sb-login-block">
                <div className="sb-login-school-header">
                    <h2 className="sb-organization-color-block-font" style={{marginTop: "0.5em", fontWeight: "bold"}}>
                        {organizationStore.organization.title}
                    </h2>
                    <h3 style={{marginTop: "0.5em"}}>Sign In</h3>
                </div>
        <LoginButtons />
            </div>
        </div>
    </div>
}
